// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4q-2";
export var blackBorderOnHover = "_4q-7";
export var cell = "_4q-6";
export var cellContainer = "_4q-3";
export var checked = "_4q-8";
export var disabled = "_4q-5";
export var featuredIconCellContainer = "_4q-9";
export var featuredIconTextContainer = "_4q-b";
export var featuredIconWrapper = "_4q-a";
export var noBorder = "_4q-c";
export var orangeSelectedRow = "_bz-3";
export var overflowableText = "_4q-0";
export var overflowableTextContainer = "_4q-1";
export var row = "_4s-0";
export var rowCheckboxCell = "_4q-4";
export var selectableTable = "_bz-2";